import {
  extend,
  filter,
  pluck,
  go,
  find,
  head,
  identity,
  indexBy,
  isArray,
  keys,
  map,
  mapObject,
  pick,
  reject,
  entries,
} from 'fxjs/es';
import { CateListConstantS } from '../../../../CateList/S/Constant/module/CateListConstantS.js';
import { PriceS } from '../../../../Price/S/Function/module/PriceS.js';
import { makeLangCollaboSql } from '../../../../Product/List/B/sql.js';
import { UtilImageS } from '../../../../Util/Image/S/Function/module/UtilImageS.js';
import { UtilLangB } from '../../../../Util/Lang/B/Function/module/UtilLangB.js';
import { VectorEditorConstantS } from '../../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { OMPProductListConstantS } from '../../S/Constant/module/OMPProductListConstantS.js';
import { OMPProductListS } from '../../S/Function/module/OMPProductListS.js';
import { BpDiscountSetS } from '../../../../BpDiscountSet/S/Function/module/BpDiscountSetS.js';
import { OMPProductListB } from './module/OMPProductListB.js';
import { campaignLikeCateItem } from '../../S/Function/campaign-like-cate-item.ts';
import { BpDiscountSetConstantS } from '@modules/BpDiscountSet/S/Constant/module/BpDiscountSetConstantS.js';

const makeProductListSubQuerySql = ({ query, is_not_use }) => {
  const custom_query = pick(
    go(
      keys(query),
      filter((key) => key.match(/f_\d/)),
      filter((key) => {
        /*
         * 가격대 해외에서는 안나오게 하드코딩
         * */
        return (
          T.lang == 'kr' ||
          key != `f_${OMPProductListConstantS.PRICE_RANGE_FILTER_LIST_ID}` ||
          !OMPProductListConstantS.HIDE_RANGE_CATE_LIST_FOR_EN_JP_IDS.includes(parseInt(query.cate_list_id))
        );
      }),
    ),

    extend(
      query,
      mapObject((val) => (isArray(val) ? go(val, map(parseInt), filter(identity)) : val), query),
    ),
  );
  const f_tag = reject((id) => !id || id == -1, query.f_tag);
  return SQL`
    SELECT bp.id
    FROM base_products as bp ${SQLS([
      query.f_color
        ? SQL`
          INNER JOIN
            base_product_colors as bpc
          ON
            bpc.base_product_id=bp.id AND
            bpc.is_public=true AND
            bpc.is_hidden=false AND ${IN('bpc.color_filter_id', query.f_color)}`
        : EMPTY,
      query.f_size
        ? SQL`
          INNER JOIN
            base_product_sizes as bps
          ON
            bps.base_product_id=bp.id AND
            bps.is_public=true AND
            bps.is_hidden=false AND ${IN('bps.size_filter_id', query.f_size)}`
        : EMPTY,
      query.f_tag
        ? (function (query) {
            if (f_tag.length) {
              /* 세일 말고도 체크된게 있음 */
              if (_p.index_of(query.f_tag, -1) > -1) {
                /* 그중에 세일이 체크되어있음 */
                return SQL`
                  INNER JOIN type_categories as tc
                  ON
                    ${EQ({
                      'tc.attached_id': CL('bp.id'),
                      'tc.attached_type': 'bp_tag_filters',
                    })}
                  INNER JOIN categories as c
                  ON
                    tc.category_id=c.id AND
                    c.is_hidden=false AND
                    c.is_public=true AND
                    (${IN('c.id', f_tag)}
                      OR ${CL(UtilLangB.col('bp.original_price'))} > ${CL(UtilLangB.col('bp.price'))})`;
              } else {
                /* 세일은 체크안되어 있음 */
                return SQL`
                  INNER JOIN type_categories as tc
                  ON
                    ${EQ({
                      'tc.attached_id': CL('bp.id'),
                      'tc.attached_type': 'bp_tag_filters',
                    })}
                  INNER JOIN categories as c
                  ON
                    tc.category_id=c.id AND ${IN('c.id', f_tag)}`;
              }
            } else {
              /* 세일만 체크 되었음 */
              return SQL`
                INNER JOIN type_categories as tc
                ON
                  ${EQ({
                    'tc.attached_id': CL('bp.id'),
                    'tc.attached_type': 'bp_tag_filters',
                  })}
                INNER JOIN categories as c
                ON
                  tc.category_id=c.id AND
                  c.is_hidden=false AND
                  c.is_public=true AND
                  ${CL(UtilLangB.col('bp.original_price'))} > ${CL(UtilLangB.col('bp.price'))}`;
            }
          })(query)
        : EMPTY,
    ])}
    WHERE
      1=1
      ${query.cate_list_id ? SQL`AND bp.cate_list_id=${parseInt(query.cate_list_id)}` : EMPTY}
      ${query.cate_item_id && !campaignLikeCateItem.isCampaign(query) ? SQL`AND bp.cate_item_id=${parseInt(query.cate_item_id)}` : EMPTY}
      ${
        query.is_change_bp == 'true'
          ? SQL`AND ${NOT_IN('bp.maker_type', VectorEditorConstantS.EDITOR_TYPES)}`
          : EMPTY
      }
      ${query.f_brand ? SQL`AND ${IN('bp.brand_filter_id', query.f_brand)}` : EMPTY}
      ${SQLS(
        map(
          ([key, ids]) => SQL`
            AND bp.id in (
              SELECT b.id
              FROM base_products as b, bp_filter_lists as bfl, bp_filter_list_filter_items as bflfi, filter_items as f
              WHERE
                f.is_hidden=false AND
                f.is_public=true AND
                b.id=bfl.base_product_id AND
                bfl.filter_list_id = ${parseInt(key.replace('f_', ''))} AND
                bflfi.bp_filter_list_id=bfl.id AND
                ${
                  !isArray(ids) && key == 'f_29'
                    ? SQL`bflfi.filter_item_id IN (${ids})`
                    : IN('bflfi.filter_item_id', ids)
                })`,
          Object.entries(custom_query),
        ),
      )}`;
};

export function getBpOrderingSql(sort) {
  const no = SQL`base_products.no, base_products.id`;
  if (sort == 'low_price') {
    return SQL`${CL(UtilLangB.col('base_products.price'))}, ${no}`;
  } else if (sort == 'high_price') {
    return SQL`${CL(UtilLangB.col('base_products.price'))} desc, ${no}`;
  } else {
    return SQL`${no}`;
  }
}
const _index_by_bp_first = {
  date: Date.now(),
  list: [],
};
export const indexByBpIdFirstSaleQuery = async () => {
  if (Date.now() - _index_by_bp_first.date > 24 * 60 * 60 * 1000 || !_index_by_bp_first.list.length) {
    _index_by_bp_first.date = Date.now();
    _index_by_bp_first.list = await RR.QUERY`
      SELECT *
      FROM (
        SELECT bp.id, ci.name, ci.name_en, ci.name_jp,
         ROW_NUMBER() OVER (PARTITION BY cate_item_id ORDER BY order_quantity DESC) AS row_num
        FROM base_products bp
        INNER JOIN cate_items ci
        ON bp.cate_item_id=ci.id
      ) A
      WHERE A.row_num=1`;
  }

  return go(
    _index_by_bp_first.list,
    indexBy(({ id }) => id),
  );
};

export const baseProductListAM = (user_id) => () =>
  RR.ASSOCIATE_MODULE`
  ${
    user_id
      ? () => RR.ASSOCIATE_MODULE`
                      - base_products_like ${{
                        left_key: 'id',
                        key: 'base_product_id',
                        query: SQL`AND user_id=${user_id}`,
                      }}`
      : () => RR.ASSOCIATE_MODULE``
  }
  - brand ${{
    table: 'categories',
    left_key: 'brand_filter_id',
    key: 'id',
    column: CL(UtilLangB.colAs('name')),
  }}
  < base_product_tags ${{
    column: CL(UtilLangB.colAs('name')),
    query: SQL`ORDER BY no`,
  }}
  < base_product_colors ${{
    column: CL('id', 'color_filter_id', 'product_thumb_url', 'color_code', 'color_code2', 'is_thumb'),
    query: SQL`WHERE ${EQ({
      is_hidden: false,
      is_public: true,
    })} ORDER BY no`,
  }}
  - reviews ${{
    left_key: 'id',
    key: 'base_product_id',
    query: SQL`WHERE is_hidden=false AND collabo_type='' AND is_public GROUP BY base_product_id`,
    column: SQL`base_product_id, COUNT(id) as count, ROUND(AVG(score), 2) as score`,
  }}
  - bp_discount_set ${{
    left_key: 'id',
    key: 'base_product_id',
    query: SQL`WHERE deleted_at IS NULL AND ${IN('type', BpDiscountSetS.getTypesFromApp())}`,
  }}
    < bp_discount_ranges ${{
      column: CL(
        UtilLangB.colAs('price'),
        'start',
        UtilLangB.colAs('min_option_price'),
        'is_default',
        'is_additional_show',
      ),
      query: SQL`ORDER BY start`,
    }}
  < base_products_custom_badges ${{
    column: SQL`${CL(UtilLangB.colAs('custom_badges.name'))}`,
    join: SQL`INNER JOIN custom_badges ON base_products_custom_badges.custom_badge_id = custom_badges.id`,
    query: SQL`ORDER BY no`,
    hook: (bpb) => {
      // 2개만
      return bpb.filter((_, i) => i < 2);
    },
  }}
`;

async function queryCampaignItems(
  { sub_query, campaign_id, session, sort, is_biz: _is_biz, is_internal_public },
  offset,
  limit,
) {
  const is_low_price = sort === 'low_price';
  const is_high_price = sort === 'high_price';
  const is_biz = _is_biz === 'true' || _is_biz === true;
  const campaign_items = await RR.ASSOCIATE`
    campaigns_campaign_items ${{
      query: SQL`
          JOIN campaign_items ON campaign_items.id = campaigns_campaign_items.campaign_item_id AND ${is_internal_public ? SQL`(campaign_items.is_public = true OR campaign_items.is_internal_public = true)` : SQL`campaign_items.is_public = true`}
          JOIN products as p ON p.id = campaign_items.product_id
          JOIN base_products ON base_products.id = p.base_product_id
          LEFT JOIN biz_products ON biz_products.base_product_id = p.base_product_id
          WHERE 
            campaigns_campaign_items.campaign_id = ${campaign_id} AND campaign_items.is_hidden = false ${is_biz ? SQL`AND biz_products.base_product_id is not null AND biz_products.is_public` : SQL``}
        ORDER BY ${is_low_price ? SQL`p.price` : is_high_price ? SQL`p.price desc` : SQL`campaigns_campaign_items.no`}
        OFFSET ${offset || 0}
        LIMIT ${limit || null}`,
      column: CL(
        SQL`base_products.id as id`,
        SQL`p.base_product_size_id as base_product_size_id`,
        SQL`p.id as product_color_id`,
        SQL`campaign_items.name as name`,
        SQL`p.price`,
        SQL`p.price_info`,
        SQL`0 as print_price`,
        SQL`campaign_items.thumbnail_url model_thumb_url`,
        SQL`'' as one_line_description`,
        SQL`base_products.cate_list_id`,
        SQL`base_products.cate_item_id`,
        SQL`base_products.is_color_for_list`,
        SQL`base_products.order_quantity`,
        SQL`campaigns_campaign_items.no`,
        SQL`0 like_count`,
        SQL`base_products.maker_features`,
        SQL`base_products.is_bpc_hidden`,
      ),
    }}
  `;
  const bp_ids = go(campaign_items, pluck('id'));
  const base_products = await RR.ASSOCIATE`
    base_products ${{
      query: SQL`WHERE ${IN('id', bp_ids)}
    `,
    }}
      ${baseProductListAM(session.user_id)} 
      - biz_product ${{
        left_key: 'id',
        key: 'base_product_id',
        query: SQL`AND is_public`,
      }}
  `;
  const indexed_bp = indexBy(({ id }) => id, base_products);
  return go(
    campaign_items,
    map((campaign_item) => {
      const bp = indexed_bp[campaign_item.id];
      return {
        ...campaign_item,
        is_campaign: true,
        _: {
          ...bp._,
        },
      };
    }),
  );
}

export const select = async ({
  query,
  session,
  subQuerySql = makeProductListSubQuerySql,
  orderBySql = getBpOrderingSql,
  tag_type = null,
  is_mobile = false,
  is_campaign_internal_public = false,
}) => {
  const { sort, offset, limit, is_not_use, lang_col, is_biz } = query;
  const index_by_bp_first = await indexByBpIdFirstSaleQuery();
  const campaign_id = campaignLikeCateItem.getCampaignId(query);
  return go(
    subQuerySql({ query, is_not_use: query.is_not_use, session }),
    (sub_query) =>
      campaign_id
        ? queryCampaignItems(
            {
              sub_query,
              campaign_id,
              session,
              sort,
              is_biz,
              is_internal_public: is_campaign_internal_public,
            },
            offset,
            limit,
          )
        : RR.ASSOCIATE`
        base_products ${{
          query: SQL`
          WHERE
            base_products.id in (${sub_query})
            AND ${
              is_not_use
                ? makeLangCollaboSql(lang_col)
                : SQL`
              ${CL(UtilLangB.col('is_use'))}=true AND
              base_product_color_face_url is not null`
            }
            AND is_hidden=false
            AND is_public
            AND id != 2984
            ${is_biz?.toString() === 'true' ? SQL`AND EXISTS (SELECT 1 FROM biz_products WHERE biz_products.base_product_id = base_products.id AND biz_products.is_public)` : EMPTY}
            ORDER BY ${orderBySql(sort)}
            OFFSET ${offset || 0}
            LIMIT ${limit || null}`,
          column: CL(
            'id',
            'product_color_id',
            UtilLangB.colAs('name'),
            UtilLangB.colAs('original_price'),
            UtilLangB.colAs('price'),
            UtilLangB.colAs('print_price'),
            UtilLangB.colAs('model_thumb_url'),
            UtilLangB.colAs('one_line_description'),
            'cate_list_id',
            'cate_item_id',
            'is_color_for_list',
            'order_quantity',
            'no',
            'like_count',
            'maker_features',
            'is_bpc_hidden',
          ),
        }}
          ${baseProductListAM(session.user_id)}
          - biz_product ${{
            left_key: 'id',
            key: 'base_product_id',
            query: SQL`AND is_public`,
          }}
        `,
    OMPProductListS.setBpsBrand,
    async (bps) => {
      const index_by_cate_item_id_for_total_review_count =
        await OMPProductListB.indexByCateItemIdForTotalReviewCount(session.user_id);
      bps.forEach((bp) => {
        const review = index_by_cate_item_id_for_total_review_count[bp.cate_item_id];
        if (review) {
          Object.assign(bp._.reviews, review);
        }
      });
      return bps;
    },
    map((bp) => {
      const bp_first = bp.is_campaign ? null : index_by_bp_first[bp.id];
      const is_discount = bp.is_campaign ? false : parseFloat(bp.original_price) > parseFloat(bp.price);

      let discount_ranges = {
        price_ranges: [
          {
            start: 1,
            price_text: PriceS.pricify(PriceS.add(bp.price, bp.print_price)),
          },
        ],
        is_one: true,
      };
      if (bp.is_campaign) {
        discount_ranges = getPrintRangesFromPriceInfo(
          bp.price_info,
          bp.base_product_size_id,
          bp._?.bp_discount_set,
        );
      } else if (bp._?.bp_discount_set?._?.bp_discount_ranges?.length) {
        discount_ranges = getPriceRanges(bp);
      }

      const badges = OMPProductListB.getBadges(tag_type, {
        bp_first,
        is_mobile,
        is_discount,
        discount_ranges,
        bp,
      });

      return {
        ...bp,
        model_thumb_url: UtilImageS.getResizedUrl({
          url: bp.model_thumb_url,
          width: 800,
          format: 'webp',
          quality: 100,
        }),
        is_discount,
        name: bp.name.replace(bp._.brand.name, '').trim(),
        minimum_price_text: TT('product::list::list_12_1', {
          price: PriceS.pricify(PriceS.add(bp.price, bp.print_price)),
        }),
        original_price_text: TT('product::list::list_13_1', {
          price: PriceS.pricify(PriceS.add(bp.original_price, bp.print_price)),
        }),
        badges: badges.slice(0, 2),
        ...discount_ranges,
      };
    }),
  );
};
export const getPrintRangesFromPriceInfo = (price_info, base_product_size_id, bp_discount_set) => {
  const bp_discount_ranges = bp_discount_set?._?.bp_discount_ranges;
  const start_quantity = bp_discount_ranges?.[0]?.start || 1;
  const ranges = go(
    price_info.discounted_product_prices && Object.keys(price_info.discounted_product_prices)?.length > 0
      ? price_info.discounted_product_prices
      : go(price_info.sizes_prices, entries, head, ([_, size_price]) => size_price.discounted_product_prices),
    entries,
  );
  const second_quantity =
    bp_discount_set?.type === BpDiscountSetConstantS.TYPE.MP_WOW
      ? Number(ranges[1][0])
      : go(
          bp_discount_ranges,
          find((bp_discount_range) => bp_discount_range.is_additional_show),
          (bp_discount_range) =>
            bp_discount_range ? bp_discount_range.start : bp_discount_ranges?.[1]?.start,
        );

  const first_price_set = go(undefined, () => {
    const default_price = campaignLikeCateItem.getDiscountRanges(
      start_quantity,
      price_info,
      base_product_size_id,
    );
    return {
      start: start_quantity,
      price: default_price,
      price_text: PriceS.pricify(default_price),
      total_price_text: PriceS.pricify(default_price * start_quantity || 1),
    };
  });
  const second_price_set = go(undefined, () => {
    if (!second_quantity) return;
    const default_price = campaignLikeCateItem.getDiscountRanges(
      second_quantity,
      price_info,
      base_product_size_id,
    );
    return {
      start: second_quantity,
      price: default_price,
      price_text: PriceS.pricify(default_price),
      total_price_text: PriceS.pricify(default_price * second_quantity || 1),
    };
  });
  first_price_set.is_default = true;
  if (second_price_set) {
    const default_price = first_price_set.price;
    const second_price = second_price_set.price;
    const percent = Math.round(((default_price - second_price) / default_price) * 100);
    second_price_set.percent = percent;
  }

  if (second_price_set?.percent > 0) {
    return {
      price_ranges: [first_price_set, second_price_set],
      is_one: false,
      is_moq: first_price_set.start > 1,
    };
  }
  return {
    price_ranges: [first_price_set],
    is_one: false,
    is_moq: first_price_set.start > 1,
  };
};

export const getPriceRanges = (base_product) => {
  const per_and_sale_price_ranges = [];

  const length = base_product?._?.bp_discount_set?._?.bp_discount_ranges?.length || 0;
  const is_use_origin_price = base_product?._?.biz_product?.is_use_origin_price;
  let is_one = false;
  let is_moq = false;
  let is_additional_show = false;

  const default_range = go(
    base_product?._?.bp_discount_set?._?.bp_discount_ranges || [],
    filter((bdr) => bdr.is_default),
    head,
  );
  if (!length || !default_range) {
    return {
      price_ranges: per_and_sale_price_ranges,
      is_one,
      is_moq,
      is_use_origin_price,
    };
  }
  const default_price = PriceS.add(default_range.price, default_range.min_option_price || 0);
  per_and_sale_price_ranges.push({
    start: default_range.start,
    percent: default_range.percent,
    price: default_price,
    price_text: PriceS.pricify(default_price),
    total_price_text: PriceS.pricify(default_price * default_range.start || 1),
    is_default: default_range.is_default,
  });
  if (default_range.start > 1) {
    is_moq = true;
  }

  base_product?._?.bp_discount_set?._?.bp_discount_ranges
    ?.sort((a, b) => b.price - a.price)
    .forEach((bdr, i) => {
      if (bdr.start === 1) {
        is_one = true;
      }

      if (!is_use_origin_price && !bdr.is_default && bdr.is_additional_show) {
        is_additional_show = true;
        const price = PriceS.add(bdr.price, bdr.min_option_price || 0);
        const percent = Math.round(((default_price - price) / default_price) * 100);
        per_and_sale_price_ranges.push({
          start: bdr.start,
          percent,
          price,
          price_text: PriceS.pricify(price),
          total_price_text: PriceS.pricify(price * bdr.start || 1),
          is_default: bdr.is_default,
        });
        return;
      }
      if (!is_use_origin_price && !is_additional_show && i === length - 1) {
        // higher sale price
        const price = PriceS.add(bdr.price, bdr.min_option_price || 0);
        const percent = Math.round(((default_price - price) / default_price) * 100);
        if (percent > 0) {
          per_and_sale_price_ranges.push({
            start: bdr.start,
            percent,
            price,
            price_text: PriceS.pricify(price),
            total_price_text: PriceS.pricify(price * bdr.start || 1),
            is_default: bdr.is_default,
          });
        }
      }
    });
  per_and_sale_price_ranges.sort((a, b) => a.start - b.start);
  return {
    price_ranges: per_and_sale_price_ranges,
    is_one,
    is_moq,
    is_use_origin_price,
  };
};

export const indexByCateItemIdForTotalReviewCount = (user_id) => {
  return go(
    RR.QUERY`
      SELECT bp.cate_item_id, count(1), ROUND(AVG(r.score), 2) as score
      FROM reviews r
             INNER JOIN base_products bp
                        ON r.base_product_id = bp.id
      WHERE ${IN('bp.cate_item_id', [
        /* 카테고리로 리뷰를 합쳐주기 때문
         * 폰케이스는 리뷰가 아니라 filters.id == 29 (타입) 으로 그룹되어있어서 이거로는 불가능
         * */
        CateListConstantS.HD_METAL_FRAME_ITEM_ID,
        CateListConstantS.TATTOO_ITEM_ID,
        CateListConstantS.HANDY_STICKER_ITEM_ID,
        CateListConstantS.KEY_CAP_ITEM_ID,
        CateListConstantS.SPECIFIC_STICKER_ITEM_ID,
        CateListConstantS.FREE_STICKER_ITEM_ID,
      ])}
        AND r.collabo_type = ''
        AND r.is_hidden = false
        AND (r.user_id = ${user_id} OR r.is_public = true)      
      GROUP BY 1;`,
    indexBy(({ cate_item_id }) => {
      return cate_item_id;
    }),
  );
};
